import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchPricingScheduler } from './pricingSchedulerSaga';
import { watchKatalog } from './katalogSaga';
import { watchZumAngebot } from './zumAngebotSaga';
import { watchDeleteGroup } from './deleteGroupSaga';
import { watchGroupFailure } from './groupFailureSaga';
import { watchLateAck } from './lateAckSaga';
import { watchChildLinkHeal } from './childLinkHealSaga';
import { watchInsDashboard } from './insDashboardSaga';
import { watchOrphanedOffers } from './orphanedOffersSaga';
import { watchJuristisch } from './juristischSaga';
import { watchTiergruppeEdit } from './tiergruppeEditSaga';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { watchChildActionForwarding } from './childActionForwardingSaga';
import { watchAngebotAdopt } from './angebotAdoptSaga';
import { watchAngebotChildHeal } from './angebotChildHealSaga';
import { watchEingabeTarget } from './eingabeTargetSaga';

export function* rootSaga() {
  yield all([
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    watchKatalog(),
    watchZumAngebot(),
    watchPricingScheduler(),
    watchOrphanedOffers(),
    watchJuristisch(),
    watchDeleteGroup(),
    watchInsDashboard(),
    watchGroupFailure(),
    watchTiergruppeEdit(),
    watchLateAck(),
    watchChildLinkHeal(),
    watchChildActionForwarding(),
    watchAngebotAdopt(),
    watchAngebotChildHeal(),
    watchEingabeTarget(),
  ]);
}
